import { PublicOnly, RequireAuth } from '@iris/ui/auth/guards';
import { createBrowserRouter } from 'react-router-dom';

import { Layout } from './layout';
import { RouteError } from './route-error';

/**
 * Routes are lazy-loaded chunks (T4 §1.3). Ops has no forgot-password screen: Ops accounts are managed with
 * `pnpm ops:create` (FR-AUTH-09). M27: shops (FR-OPS-01/05, ADR 0007); M28: customers, alerts,
 * categories and holidays, audit log (FR-OPS-02..04, ADR 0008).
 */
export const router = createBrowserRouter([
  {
    element: <Layout />,
    errorElement: <RouteError />,
    children: [
      {
        element: <PublicOnly />,
        children: [
          {
            path: 'login',
            lazy: async () => {
              const { LoginScreen } = await import('@iris/ui/auth/login-screen');
              return { Component: () => <LoginScreen titleKey="auth.login.opsTitle" /> };
            },
          },
        ],
      },
      {
        element: <RequireAuth />,
        children: [
          { index: true, lazy: () => import('./routes/dashboard') },
          { path: 'merchants', lazy: () => import('./routes/merchants') },
          { path: 'merchants/:id', lazy: () => import('./routes/merchant') },
          { path: 'customers', lazy: () => import('./routes/customers') },
          { path: 'customers/:id', lazy: () => import('./routes/customer') },
          { path: 'alerts', lazy: () => import('./routes/alerts') },
          { path: 'config', lazy: () => import('./routes/config') },
          { path: 'audit', lazy: () => import('./routes/audit') },
          { path: 'test-data', lazy: () => import('./routes/test-data') },
        ],
      },
      { path: '*', lazy: () => import('./routes/not-found') },
    ],
  },
]);
